import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { intlShape, injectIntl } from "react-intl";
import { Loader, Button } from "cxa-components";
import { isEmpty, compose } from "cxa-utils";
import messages from "components/messagesDescription";
import { load } from "actions/wellnessLaunchpadActions";

const WellnessLaunchpad = ({ response: { assessmentStatus, profilePhoto = {} }, intl, load }) => {
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    load().finally(() => {
      setIsLoading(false);
    });;
  }, []);

  if (isEmpty(assessmentStatus) || isLoading) {
    return <Loader />;
  }

  const {
    faceAgingCompleted,
    agingPhotoSubmitted,
    hraQuestionsAnswered,
    advancedScreeningCompleted,
    hRAEnabled,
    hRATitle,
    advancedScreeningEnabled,
    advancedScreeningTitle,
    learningChannelEnabled,
    learningChannelTitle,
  } = assessmentStatus;

  // Set Lifestyle Ageing Details
  let lifestyleAgeingDesc = messages.lifestyleAgeingDescDefaultDescription;
  let lifestyleAgeingBtn = messages.viewTextDescription;
  let lifestyleAgeingStatus = messages.lifestyleAgeingStatusStartDescription;

  if (faceAgingCompleted === "true") {
    lifestyleAgeingDesc = messages.lifestyleAgeingDescCompletedDescription;
    lifestyleAgeingBtn = messages.viewTextDescription;
    lifestyleAgeingStatus = messages.availableTextDescription;
  }

  if (agingPhotoSubmitted === "true" && hraQuestionsAnswered === "true") {
    lifestyleAgeingDesc = messages.lifestyleAgeingDescPSubmittedDescription;
    lifestyleAgeingBtn = messages.viewTextDescription;
    lifestyleAgeingStatus = messages.lifestyleAgeingStatusProcessingDescription;
  }

  // Set Advanced Screening Details
  let advancedScreeningDesc = messages.screeningDescNotDescription;
  let advancedScreeningBtn = messages.startHereTextDescription;
  let advancedScreeningStatus = messages.unavailableTextDescription;

  if (advancedScreeningCompleted === "true") {
    advancedScreeningDesc = messages.advancedScreeningDescYesDescription;
    advancedScreeningBtn = messages.viewTextDescription;
    advancedScreeningStatus = messages.availableTextDescription;
  }


  const Card = ({ enable, name, image, desc, status, url, button }) => {
    if (enable == "true") {
      return (
        <article className="card grid__item grid__item--three">
          <header>
            <h2>
              {intl.formatMessage({
                id: name,
                defaultMessage: name,
              })}
            </h2>
          </header>

          <section>
            <figure>
              <img src={image} alt={name} />
            </figure>
            <p>{desc}</p>
            <div className={status} />
          </section>

          <footer>
            <p>
              <Button href={url} primary style={{ width: "100%" }}>
                {button}
              </Button>
            </p>
          </footer>
        </article>
      );
    }

    return null;
  };

  const profilePhotoUri = profilePhoto.uri || "../assets/images/wellness/view_aging_default.png";

  const isUserAuthorized =
    hRAEnabled === "true" ||
    advancedScreeningEnabled === "true" ||
    learningChannelEnabled === "true";

  if (isUserAuthorized) {
    return (
      <div className="grid__wrapper">
        <Card
          enable={hRAEnabled}
          name={hRATitle}
          image={profilePhotoUri}
          desc={intl.formatMessage(lifestyleAgeingDesc)}
          button={intl.formatMessage(lifestyleAgeingBtn)}
          status={intl.formatMessage(lifestyleAgeingStatus)}
          url={
            hRAEnabled === "true" && hraQuestionsAnswered === "true"
              ? "/wellness/lifestyleAgeing/results"
              : "/wellness/lifestyleAgeing/ageYourSelf"
          }
        />

        <Card
          enable={advancedScreeningEnabled}
          name={advancedScreeningTitle}
          image="../assets/images/wellness/icon-health-screening.jpg"
          desc={intl.formatMessage(advancedScreeningDesc)}
          button={intl.formatMessage(advancedScreeningBtn)}
          status={intl.formatMessage(advancedScreeningStatus)}
          url="/wellness/screening-results/advanced"
        />

        <Card
          enable={learningChannelEnabled}
          name={learningChannelTitle}
          image="../assets/images/wellness/icon-learning-channel2.png"
          desc={intl.formatMessage(messages.readBenefitTextDescription)}
          button={intl.formatMessage(messages.startLearningTextDescription)}
          status={intl.formatMessage(messages.availableTextDescription)}
          url="/wellness/elibrary/catalogue/"
        />
      </div>
    );
  }

  return (
    <p className="apl-notification__message">{intl.formatMessage(messages.unAuthorizedAccess)}</p>
  );
};

WellnessLaunchpad.propTypes = {
  error: PropTypes.object,
  load: PropTypes.func,
  response: PropTypes.object,
  intl: intlShape.isRequired,
};
const mapStateToProps = ({ error, wellnessLaunchpad }) => {
  const { response } = wellnessLaunchpad;

  return {
    response,
    error,
  };
};

const mapDispatchToProps = { load };

export default compose(injectIntl, connect(mapStateToProps, mapDispatchToProps))(WellnessLaunchpad);



// WEBPACK FOOTER //
// ./components/wellness/wellnessLaunchpad.jsx